import { render } from "./SyncDocumentError.vue?vue&type=template&id=4346a569&scoped=true"
import script from "./SyncDocumentError.vue?vue&type=script&lang=js"
export * from "./SyncDocumentError.vue?vue&type=script&lang=js"

import "./SyncDocumentError.vue?vue&type=style&index=0&id=4346a569&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4346a569"]])

export default __exports__